import { useQuery } from '@apollo/react-hooks'
import * as Query from '../../../api/gql/query'

/** The project's Cost Control currency (1b-B spec §6): readable by module users and by a contractor's representative alike. */
export function useCostCurrency(projectId: string | undefined): string {
  const { data } = useQuery<{ costCurrency: string }>(Query.COST_CURRENCY, {
    variables: { projectId },
    skip: !projectId,
    fetchPolicy: 'cache-and-network',
    context: { handlesErrors: true },
  })
  return data?.costCurrency ?? 'CZK'
}
